import { MutateVariablePayload, VariableSourceSettingsDto } from '@thingslog/repositories';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { VariableForm } from '../../forms';
import { DashboardSidebarWidgetCard } from './DashboardSidebarWidgetCard';

interface Props {
  widgetId: string;
  variableSources: VariableSourceSettingsDto[];
  companyId?: number | null;
  isPersisting: boolean;
  onPersistNewVariable: (
    payload: MutateVariablePayload,
    callbacks?: { onSuccess?: () => void }
  ) => void;
  onClose: (widgetId: string) => void;
  onStartTour: () => void;
}

export const DashboardSidebarVariableAddWidget: FC<Props> = ({
  widgetId,
  variableSources,
  companyId,
  isPersisting,
  onPersistNewVariable,
  onClose,
  onStartTour,
}: Props) => {
  const { t } = useTranslation();

  return (
    <DashboardSidebarWidgetCard
      title={t('dashboard_add_variable', 'Add Variable')}
      widgetId={widgetId}
      expandable
      onClose={onClose}
      onStartTour={onStartTour}
    >
      <VariableForm
        type="create"
        variableSources={variableSources}
        companyId={companyId}
        disabled={isPersisting}
        onSubmit={(payload: MutateVariablePayload): void => {
          onPersistNewVariable(payload, { onSuccess: () => onClose(widgetId) });
        }}
        onCancel={(): void => {
          onClose(widgetId);
        }}
      />
    </DashboardSidebarWidgetCard>
  );
};
